export enum ELocalStorageKeys {
  CANDIDATES_TABLE_ORDER = 'CANDIDATES_TABLE_ORDER',
  PARTICIPANTS_TABLE_ORDER = 'PARTICIPANTS_TABLE_ORDER',
  CANDIDATES_TABLE_COLUMNS_WIDTH = 'CANDIDATES_TABLE_COLUMNS_WIDTH',
  PARTICIPANTS_TABLE_COLUMNS_WIDTH = 'PARTICIPANTS_TABLE_COLUMNS_WIDTH',
  MESSAGES_TABLE_ORDER = 'MESSAGES_TABLE_ORDER',
  MESSAGES_TABLE_COLUMNS_WIDTH = 'MESSAGES_TABLE_COLUMNS_WIDTH',
  SURVEY_BUILDER_LAYOUT_ALERT_HIDDEN = 'SURVEY_BUILDER_LAYOUT_ALERT_HIDDEN'
}
